import { computed, ref, type Ref, watchEffect } from 'vue';
import QRCode from 'qrcode';
import { configHelper } from '@ilteducation/config';

export function useQrCode(gameId: Ref<string | null>) {
  const joinGameUrl = computed(() => {
    if (!gameId.value) return undefined;

    // Production: use quizter.gg
    if (configHelper.isProd()) {
      return `https://quizter.gg/${gameId.value}`;
    }

    // Local development: use same origin with internal route
    if (configHelper.isLocal()) {
      return `${window.location.origin}/quizter/join/${gameId.value}`;
    }

    // Staging & CI preview: use dev.quizter.gg
    return `https://dev.quizter.gg/${gameId.value}`;
  });

  const qrCode = ref<string>();

  watchEffect(async () => {
    if (joinGameUrl.value) {
      qrCode.value = await QRCode.toDataURL(joinGameUrl.value, {});
    }
  });

  return {
    joinGameUrl,
    qrCode,
  };
}
